const firebaseConfig = {
  apiKey: "AIzaSyCbxJr2JhsdnoimpwHbNIh9zxylUgN-M4g",
  authDomain: "online-pharmacy-83bc4.firebaseapp.com",
  projectId: "online-pharmacy-83bc4",
  storageBucket: "online-pharmacy-83bc4.appspot.com",
  messagingSenderId: "16955194576",
  appId: "1:16955194576:web:318857b900c0b1707bf2d5"
};
export default firebaseConfig;